export default __webpack_public_path__ + "static/media/reward-icon.00753fb1.svg";